import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-obsidian py-8 border-t border-white/5">
      <div className="container mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-gray-500 text-xs font-mono">
          © {new Date().getFullYear()} MIDNIGHTNEURON.COM — ENGINEERED BY MIDNIGHTNEURON
        </p>
        <div className="flex gap-6">
          <span className="text-gray-600 text-xs font-mono">SYSTEM STATUS: ONLINE</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;